import { fuzzySearchUsers } from 'api/users/fuzzySearchUsers'
import { AssignableUser, SearchAssignableUsersRequest } from './types'

export async function searchAssignableUsers(
  request: SearchAssignableUsersRequest
): Promise<AssignableUser[]> {
  const users = await fuzzySearchUsers(request.keyword, 20)

  return users
    .map((user) => ({
      userId: Number(user.id),
      name: user.name ?? `User ${user.id}`,
      email: user.email ?? '',
    }))
    .filter((user) => Number.isFinite(user.userId))
}
